import moment from "moment";

export const convertUTCDateToLocalDate = (time) =>
  moment(moment.utc(time).toDate(), "YYYY-MM-DDTHH:mm:ss");
